import { createSelector } from "reselect";

import getPageName from "./location_metadata/get_page_name";
import getPageTitle from "./get_page_title";
import getProjectName from "./project_getters/get_project_name";
import { PROJECT_SETTINGS, PROJECT_TEAM } from "../../models/domain/enums/page_names";

// Project pages that getPageTitle gives no title. The reskinned top nav shows the project's name on them too,
// so the nav looks the same on every project page and its tabs don't move between pages.
const PROJECT_PAGES_WITHOUT_A_TITLE = new Set([PROJECT_SETTINGS, PROJECT_TEAM]);

// The reskinned top nav's page title: getPageTitle, plus the project's name on the pages above. The legacy
// nav keeps using getPageTitle, so it is unchanged.
const getRedesignPageTitle = createSelector([
  getPageName,
  getPageTitle,
  getProjectName
], (pageName, pageTitle, projectName) => {
  if (PROJECT_PAGES_WITHOUT_A_TITLE.has(pageName)) {
    return projectName || "";
  }
  return pageTitle;
});

export default getRedesignPageTitle;
